<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g transform="translate(-1123 -607) translate(982 415) translate(141 192)">
            <circle cx="25" cy="25" r="25" fill="#13A2E8" />
            <path fill="#FFF" d="M19 18.7v13.037c0 .553.448 1 1 1 .17 0 .337-.043.485-.125l11.741-6.519c.483-.268.657-.877.39-1.36-.091-.163-.226-.298-.39-.389l-11.74-6.52c-.483-.267-1.092-.093-1.36.39-.083.148-.126.315-.126.485zm2.455 2.472l7.287 4.047-7.287 4.044v-8.091z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>